/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AnalyticValueIds } from '../model/analyticValueIds';
// @ts-ignore
import { DatachangeMultiDataEdit } from '../model/datachangeMultiDataEdit';
// @ts-ignore
import { DatachangeMultiDataEdited } from '../model/datachangeMultiDataEdited';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    DatachangeServiceInterface
} from './datachange.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class DatachangeService extends BaseService implements DatachangeServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Gets the datachange data by multiSetId
     * This endpoint returns the data that can be edited by the given multi_type id IMPORTANT: THIS ENDPOINT IS ONLY AN INTERIM SOLUTION FOR PROIN-297 AND MUST BE REPLACED ONCE PROIN-299 IS IMPLEMENTED 
     * @param analyticProcessId ID of the analytic process
     * @param username This is the user who wants to make the changes to the data
     * @param analyticValueIds Analytic value IDs array
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatachangeMultiEditDataByTypeId(analyticProcessId: number, username: string, analyticValueIds: AnalyticValueIds, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DatachangeMultiDataEdit>;
    public getDatachangeMultiEditDataByTypeId(analyticProcessId: number, username: string, analyticValueIds: AnalyticValueIds, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DatachangeMultiDataEdit>>;
    public getDatachangeMultiEditDataByTypeId(analyticProcessId: number, username: string, analyticValueIds: AnalyticValueIds, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DatachangeMultiDataEdit>>;
    public getDatachangeMultiEditDataByTypeId(analyticProcessId: number, username: string, analyticValueIds: AnalyticValueIds, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (analyticProcessId === null || analyticProcessId === undefined) {
            throw new Error('Required parameter analyticProcessId was null or undefined when calling getDatachangeMultiEditDataByTypeId.');
        }
        if (username === null || username === undefined) {
            throw new Error('Required parameter username was null or undefined when calling getDatachangeMultiEditDataByTypeId.');
        }
        if (analyticValueIds === null || analyticValueIds === undefined) {
            throw new Error('Required parameter analyticValueIds was null or undefined when calling getDatachangeMultiEditDataByTypeId.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>analyticProcessId, 'analyticProcessId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>username, 'username');

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/datachange`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DatachangeMultiDataEdit>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: analyticValueIds,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update the datachange data by multiSetId
     * Update the datachange data by multiSetId
     * @param multiSetId ID of the multi type with the given data
     * @param datachangeMultiDataEdited List of data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDatachangeMultiDataByTypeId(multiSetId: number, datachangeMultiDataEdited: DatachangeMultiDataEdited, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<string>>;
    public updateDatachangeMultiDataByTypeId(multiSetId: number, datachangeMultiDataEdited: DatachangeMultiDataEdited, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<string>>>;
    public updateDatachangeMultiDataByTypeId(multiSetId: number, datachangeMultiDataEdited: DatachangeMultiDataEdited, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<string>>>;
    public updateDatachangeMultiDataByTypeId(multiSetId: number, datachangeMultiDataEdited: DatachangeMultiDataEdited, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (multiSetId === null || multiSetId === undefined) {
            throw new Error('Required parameter multiSetId was null or undefined when calling updateDatachangeMultiDataByTypeId.');
        }
        if (datachangeMultiDataEdited === null || datachangeMultiDataEdited === undefined) {
            throw new Error('Required parameter datachangeMultiDataEdited was null or undefined when calling updateDatachangeMultiDataByTypeId.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (cookieAuth) required

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/datachange/${this.configuration.encodeParam({name: "multiSetId", value: multiSetId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<string>>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: datachangeMultiDataEdited,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
